import { Link } from 'react-router-dom';
import { Activity } from 'lucide-react';

export function Footer() {
  const linkClass = 'footer-link transition-colors';

  return (
    <footer className="footer-surface py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-8 md:flex-row">
          <div className="flex items-center gap-3">
            <div
              className="flex h-11 w-11 items-center justify-center"
              style={{
                borderRadius: 'var(--radius-md)',
                background:
                  'linear-gradient(135deg, var(--color-brand), var(--color-brand-strong))',
                color: 'var(--color-on-brand)',
              }}
            >
              <Activity className="h-6 w-6" />
            </div>
            <span className="text-xl font-bold footer-heading">TrackWithAI</span>
          </div>

          <nav className="flex flex-wrap justify-center gap-6 text-sm">
            <Link to="/start" className={linkClass}>Try The Coach</Link>
            <Link to="/coaches" className={linkClass}>For Coaches</Link>
            <Link to="/login" className={linkClass}>Sign In</Link>
            <Link to="/legal" className={linkClass}>Terms of Service</Link>
            <Link to="/legal" className={linkClass}>Privacy Policy</Link>
            <Link to="/legal" className={linkClass}>Refund Policy</Link>
          </nav>
        </div>

        <div className="footer-divider mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} TrackWithAI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
